module.exports = __webpack_public_path__ + "img/1.765ef3b2.png";